import { Badge, ButtonGroup, Dropdown, Spinner } from 'react-bootstrap';
import { APARTMENT_STATUS, APARTMENT_STATUS_LABELS } from '../../helpers/constants';
import React from 'react';
import { snakeCase } from 'lodash';
import { statusToColorMap } from '../../helpers/global';

export const ApartmentColEditStatusDropdown = ({ apartment, handleStatusChange, translate, isUpdating = false }) => {
  const [show, setShow] = React.useState(false);
  const dropdownRef = React.useRef(null);

  React.useEffect(() => {
    const handleClickOutside = e => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShow(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = isOpen => setShow(isOpen);

  const onSelectStatus = newStatus => {
    handleStatusChange(newStatus);
    setShow(false);
  };

  return (
    <div ref={dropdownRef} onClick={e => e.stopPropagation()}>
      <Dropdown show={show} onToggle={handleToggle} as={ButtonGroup} className="bg-primary">
        <Badge
          style={{ borderRadius: '5px', padding: '2px' }}
          bg={statusToColorMap[apartment.status] || 'primary text-white'}
          className="d-flex align-items-center m-0"
        >
          <span className="tiny p-0 px-1" onClick={() => setShow(prev => !prev)}>
            {apartment.status ? translate(snakeCase(apartment.status)) || apartment.status : '-'}
          </span>
          {isUpdating && <Spinner animation="border" style={{ width: '12px', height: '12px' }} className="ms-1" />}
          <Dropdown.Toggle
            variant={statusToColorMap[apartment.status] || 'primary text-white'}
            style={{ margin: 0, fontSize: '0.7rem' }}
            className="border-0 p-0 px-1"
            disabled={isUpdating}
          />
        </Badge>
        <Dropdown.Menu>
          {APARTMENT_STATUS.map(s => {
            const label = APARTMENT_STATUS_LABELS[s];
            return (
              <Dropdown.Item
                active={apartment.status === label}
                key={s}
                onClick={() => onSelectStatus(label)}
                disabled={isUpdating || s === 'preparing_contract' || s === 'bought_by_our_client'}
              >
                {translate(s)}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};
